import React from 'react';

import { PreviewValue } from '../Editor';
import { Testimonial } from '~/types/models/testimonial';
import { Tag } from '~/types/models/tags';

export interface EditorContextProps {
  testimonial: Testimonial;
  originalTestimonial: Testimonial;
  update: (updates: Testimonial) => void;
  tags: Tag[];
  updateTags: (tags: Tag[]) => void;
  preview?: PreviewValue;
  hasChanges?: boolean;
  hasUpdated: boolean;
  setHasUpdated: (updated: boolean) => void;
  upgradePrompted: boolean;
  setUpgradePrompted: (updated: boolean) => void;
  updateDomain: (domain: number) => void;
  domain: number | null;
}

export default React.createContext<EditorContextProps>({
  testimonial: {} as Testimonial,
  originalTestimonial: {} as Testimonial,
  update: () => undefined,
  tags: [],
  updateTags: () => undefined,
  hasUpdated: false,
  hasChanges: false,
  setHasUpdated: () => false,
  upgradePrompted: false,
  setUpgradePrompted: () => false,
  updateDomain: () => undefined,
  domain: null,
});
